<template>
  <el-container class="TransactionPrint">
    <el-main ref="printTransaction" style="padding: 0">
      <div class="w-full flex">
        <div class="header_side">&nbsp;</div>
        <div class="flex-auto center">
          <h1 class="w-full title-bar">출 하 품 목</h1>
        </div>
        <div class="header_side" style="text-align: right; overflow: hidden;">
          <VueBarcode
            v-bind:value="data.code"
            height="40"
            fontSize="14"
            margin="0"
            :width="2"
            :text="data.code"
          />
        </div>
      </div>
      <div class="w-full flex mt-default">
        <div class="flex-auto">
          <table class="w-full border transaction" border="0" cellspacing="0" cellpadding="6">
            <tr>
              <td width="15%" class="bg-dark align-center">상 호</td>
              <td width="35%">{{data.customer_name}}</td>
              <td width="15%" class="bg-dark align-center">연락처</td>
              <td width="35%">{{data.tel}}</td>
            </tr>
            <tr>
              <td class="bg-dark align-center">주 소</td>
              <td colspan="3">{{data.destination}}</td>
            </tr>
            <tr>
              <td class="bg-dark align-center">납품일</td>
              <td>{{data.delivery_date}}</td>
              <td class="bg-dark align-center">발행일</td>
              <td>{{data.publish_at | date}}</td>
            </tr>
          </table>
        </div>
        <div class="flex-fixed ml-default" style="width: 45%;">
          <table class="w-full border transaction mb-default" cellspacing="0" cellpadding="2">
            <colgroup>
              <col width="20px"/>
              <col />
              <!-- <col width="60px" /> -->
              <!-- <col width="60px" />
              <col width="50px"/> -->
              <col />
            </colgroup>
            <tr>
              <th width="20%">상호</th>
              <td>(주){{company.name}}</td>
            </tr>
            <tr>
              <th>등록번호</th>
              <td>{{company.crn | crn}}</td>
            </tr>
            <tr>
              <th>소재지</th>
              <td><AFitText>{{company.addr}}</AFitText></td>
            </tr>
            <tr>
              <th>전 화</th>
              <td>{{company.tel}}</td>
            </tr>              
          </table>
        </div>
      </div>
      <div>
        <table class="w-full border table-fs12 table-fixed" border="0" cellspacing="0" cellpadding="2">
          <col width="50%">
          <col width="15%"/>
          <col width="15%"/>
          <col width="20%"/>
          <tr>
            <th>품목명</th>
            <th>규격</th>
            <th>단위</th>
            <th>수량</th>
          </tr>
          <tr
            v-for="item in data.details"
            v-bind:key="item.id"
          >
            <td>{{item.product_name}}</td>
            <td>{{item.size}}</td>
            <td>{{item.unit_name}}</td>
            <td>{{item.amount}}</td>
          </tr>
        </table>
      </div>
      <el-row type="flex" justify="space-between" style="margin-top: 6px">
        <span class="text-color-red">소프트웨어 문의: (주)아브로소프트코리아 (Tel.02-2132-5115)</span>
        <span class="text-color-red">http://www.avrosoft.co.kr</span>
      </el-row>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="clickPrint"
        @click="clickPrint"
      >인 쇄 (F8)</el-button>
      <el-button @click="closeDialog" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VueBarcode from "vue-barcode";
import { company_info } from "@/common/mixins/company_info";
import AFitText from '@/shared/AFitText';
import Print from "@/plugins/print/print";

Vue.use(Print);

export default {
  name: "TransactionPrint",
  components: { VueBarcode, AFitText },
  mixins: [company_info, ],
  data() {
    return {
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          details: []
        };
      }
    },
    details: function() {
      return this.data.details;
    }
  },
  computed: {
    ...mapGetters(["table_product"]),
    /** 상세정보 */
    masks: function() {
      return this.system.masks;
    }
  },
  created() {
    this.loadConfig();
  },
  methods: {
    clickPrint() {
      this.$print(this.$refs.printTransaction);
    },
    /** 닫기 */
    closeDialog() {
      this.$emit("completed");
    },
    resolveProductUnit(product_id) {
      let p = this.table_product.find(p => p.id === product_id);
      if (!p) {
        return "";
      }
      return p.unit_name;
    }
  }
};
</script>

<style lang="scss">
.header_side {
  width: 210px;
}
$color-bg-header: #d3d3d3;
.bg-dark {
  background-color: $color-bg-header !important;
}
</style>